import { Link } from "react-router-dom";
import { useState } from "react";

const footerLinks = [
  {
    title: "核心服务",
    links: [
      { label: "赛事直播", href: "/category/saishizhibo" },
      { label: "运动课程", href: "/category/yundongkecheng" },
      { label: "健身计划", href: "/category/jianshenjihua" },
      { label: "体育资讯", href: "/category/tiyuzixun" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { label: "品牌介绍", href: "/about" },
      { label: "联系我们", href: "/about" },
      { label: "常见问题", href: "/about" },
      { label: "用户协议", href: "/about" },
    ],
  },
  {
    title: "会员服务",
    links: [
      { label: "会员权益", href: "/about" },
      { label: "价格方案", href: "/about" },
      { label: "企业合作", href: "/about" },
      { label: "帮助中心", href: "/about" },
    ],
  },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [subscribeStatus, setSubscribeStatus] = useState<"idle" | "success" | "error">("idle");
  const [subscribeMsg, setSubscribeMsg] = useState("");

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    const form = e.currentTarget as HTMLFormElement;
    const formData = new FormData(form);
    const honeypot = formData.get("website_alt") as string;
    if (honeypot && honeypot.trim() !== "") {
      setSubscribeStatus("error");
      setSubscribeMsg("订阅失败，请稍后重试。");
      return;
    }

    try {
      formData.delete("website_alt");
      const response = await fetch("https://readdy.ai/api/form/d9u38353pcjqs2fcsl4g", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      const code = parsed?.code as string | undefined;
      if (response.ok && code === "OK") {
        setSubscribeStatus("success");
        setSubscribeMsg("订阅成功！感谢您的关注。");
        setEmail("");
      } else {
        const msg = (parsed?.meta as Record<string, unknown>)?.message as string || "订阅失败，请稍后再试。";
        setSubscribeStatus("error");
        setSubscribeMsg(msg);
      }
    } catch {
      setSubscribeStatus("error");
      setSubscribeMsg("网络错误，请检查网络后重试。");
    }
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="text-2xl font-bold text-primary-500">
                <i className="ri-basketball-line w-7 h-7 inline-flex items-center justify-center"></i>
                云体育
              </span>
            </Link>
            <p className="text-foreground-600 text-sm leading-relaxed mb-6 max-w-sm">
              云体育是专注于体育运动的一站式在线服务平台，涵盖体育赛事直播、运动课程、健身计划、体育资讯等全场景服务。让运动融入你的每一天。
            </p>
            <form
              onSubmit={handleSubscribe}
              data-readdy-form
              className="flex flex-col sm:flex-row gap-2 max-w-sm"
            >
              <div className="relative flex-1">
                <i className="ri-mail-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱订阅资讯"
                  required
                  className="w-full pl-10 pr-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                />
              </div>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="absolute opacity-0 pointer-events-none"
                style={{ position: "absolute", left: "-9999px", top: "-9999px" }}
              />
              <button
                type="submit"
                className="px-5 py-2.5 rounded-lg bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                订阅
              </button>
            </form>
            {subscribeStatus !== "idle" && (
              <p className={`mt-2 text-sm ${subscribeStatus === "success" ? "text-green-600" : "text-red-500"}`}>
                {subscribeMsg}
              </p>
            )}
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="text-sm font-semibold text-foreground-900 mb-4">{group.title}</h3>
              <ul className="flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 云体育 YunSports.com 版权所有 | 京ICP备2024XXXXXXXX号
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors w-5 h-5 flex items-center justify-center" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors w-5 h-5 flex items-center justify-center" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors w-5 h-5 flex items-center justify-center" aria-label="抖音">
              <i className="ri-tiktok-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}